var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('AsiPageTitle',{attrs:{"icon":_vm.icons.cart,"title":_vm.cartLabel,"loading":_vm.loading},scopedSlots:_vm._u([{key:"subtitle",fn:function(){return [_c('AsiBreadcrumbs',{attrs:{"entries":_vm.path,"hide-icons":"","link-entries":""}})]},proxy:true}])}),_c('CartTabDetails',{attrs:{"cart":_vm.cart}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }